import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { login } from "../components/Auth";
import { useLoading } from "../components/LoadingContext";  // ★ 追加
import "../styles/Login.css";

function Login() {
  const [loginCode, setLoginCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const { loading, startLoading, finishLoading } = useLoading();  // ★ 追加

  const handleLogin = async () => {
    setError("");
    startLoading();   // ★ スピナー開始
    try {
      await login(loginCode);
      navigate("/");
    } catch (e) {
      setError("ログインに失敗しました");
    } finally {
      finishLoading();  // ★ スピナー終了
    }
  };

  return (
    <div className="login-container" style={{ position: "relative" }}>
      <h1>ログイン</h1>
      <input
        type="text"
        placeholder="XXXX-XXXX-XXXX"
        value={loginCode}
        onChange={(e) => setLoginCode(e.target.value)}
        disabled={loading}              // ロード中は入力不可に
      />
      <button onClick={handleLogin} disabled={loading}>
        {loading ? "Loading..." : "ログイン"}
      </button>
      {error && <p className="error">{error}</p>}

      {/* オーバーレイスピナー */}
      {loading && (
        <div className="overlay-spinner">
          <div className="spinner-icon" />
            <p>Loading...</p>
        </div>
      )}
    </div>
  );
}

export default Login;
